import gql from "graphql-tag";

import authorizationCorrespondenceInfo from "./authorizationCorrespondenceInfo";
import noteInfo from "./noteInfo";
import portalInformation from "./portalInformation";

export default gql`
  fragment authorizationInfo on Authorization {
    id
    config
    status
    formId
    formDetails
    updatedAt
    submittedAt
    caremetxEnrollmentDisplayStatus
    supportsEnrollment
    enrollmentProvider
    createdById
    createdByUser
    createdAt
    version
    InstitutionId
    InsuranceCompanyId
    institutionAuthorizationId
    isArchived
    lastCheckedAt
    displayReviewWarning
    hideFromExpiring
    PortalId
    ICDs
    HCPCSCodes
    isReferral
    portalTitle
    portalAuthorizationId
    requiresAssociationReview
    emailReminderAt
    emailReminderDescription
    integratedEMRDocumentsDownloaded
    dateOfCurrentStatus
    type
    submissionPhoneNumber
    trackingStatus
    DrugOptionId
    PortalId
    paOrigin
    PrescriberId
    ReferringProviderId
    LocationId
    ReferringLocationId

    tags {
      value
    }

    customPortalSteps {
      key
      id
      display
      value
      isTerminal
      message
      type
      subType
      title
      requiresHardReset
      imageURL
      isDraft
      errorGroup
    }

    patient {
      id
      firstName
      lastName
      InsuranceCompanyId
      institutionPatientId
      dob
    }

    insuranceCompany {
      id
      name
      responseRangeMax
      responseRangeMin
      isArchived
    }

    latestCorrespondence {
      ...authorizationCorrespondenceInfo
    }

    correspondences {
      ...authorizationCorrespondenceInfo
    }

    latestNote {
      ...noteInfo
    }

    portal {
      ...portalInformation
    }

    formFieldConfig {
      requiredFields
      hiddenFields
      additionalFields
      maxIcdCount
      maxHcpcsCount
      hcpcsUnits {
        value
        label
      }
      fieldOptionsList {
        fieldKey
        maxLength
      }
    }

    followUp {
      id
      createdAt
      isReviewed
      type
    }

    steps {
      key
      title
      number
      active
      section
      belongsTo
    }

    drugConfiguration {
      useLetterOfMedicalNecessity
      lomnFields {
        key
        title
        type
        optional
      }
      appealFields {
        key
        title
        type
        optional
      }
      lomnMarkdownTemplate
      appealMarkdownTemplate
      appealFillStepHtml
      appealLetterHtml
      patientAccessInfoHtml
      payerPolicyLink
      isiHtml
      reviewAndSubmitNote
      fieldPrimaryDrugName_note
      fieldInsuranceOrganization_note
    }

    authorizationNonApprovals {
      createdAt
      updatedAt
      type
      details
      responseDueBy
    }
  }

  ${authorizationCorrespondenceInfo}
  ${noteInfo}
  ${portalInformation}
`;
